// Upload server
Cookies.set('uploadr', 'http://www.aothunthongdiep.qsv');



// WEBPACK FOOTER //
// ./ext/config.js